import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TruncatePipeModule } from '@atl-libs-shared-pipes/truncate/truncate.pipe.module';
import { SharedFormModule } from '@atlas-workspace/shared/form';
import {
  ActionMessageBannerComponent,
  CardContainerComponent,
  ImageSliderModule,
  NewestDocumentCardComponent,
  NgbModalHeaderComponent,
  ReadMoreComponent,
  ShadowDomComponent,
  SimpleTabsComponent,
  SliderGalleryViewComponent,
} from '@atlas-workspace/shared/ui';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

import { IframeCategoryDetailsComponent } from './category-details/category-details.component';
import { DownloadModalComponent } from './download-modal/download-modal.component';
import { OptionsIframeIntroductionComponent } from './introduction/options-introduction.component';
import { OptionsIframeComponent } from './options-iframe.component';
import { OptionsIframeRoutingModule } from './options-routing.module';
import { ShareModalComponent } from './share-modal/share-modal.component';
import { OptionsIframeSummaryComponent } from './summary/iframe-summary.component';
import { IframePackagesComponent } from './packages/packages.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    OptionsIframeComponent,
    IframeCategoryDetailsComponent,
    OptionsIframeSummaryComponent,
    DownloadModalComponent,
    ShareModalComponent,
    OptionsIframeIntroductionComponent,
    IframePackagesComponent
  ],
  imports: [
    CommonModule,
    OptionsIframeRoutingModule,
    ReactiveFormsModule,
    SharedFormModule,
    SimpleTabsComponent,
    CardContainerComponent,
    TruncatePipeModule,
    ReadMoreComponent,
    NgbModalHeaderComponent,
    SharedFormModule,
    ActionMessageBannerComponent,
    ShadowDomComponent,
    ImageSliderModule,
    NewestDocumentCardComponent,
    NgbTooltipModule,
    SliderGalleryViewComponent,
    TranslateModule,
  ],
})
export class OptionsIframeModule {}
